module.exports = __webpack_public_path__ + "static/ocorie-abt-2-fa28f6785aabb85b66d22f2626c5cb36.png";